import { Col, Row, Form, Space, Button, Upload, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import {
  InputCheckboxGroup,
  InputField,
  ReactSelectField,
  TextAreaField,
} from "../../../atoms/FormElement";
import { LoaderIcon } from "../../../atoms/Icons";
import { DeleteOutlined } from "@ant-design/icons";
import { uploadDocumentMedia, uploadToS3 } from "../../../../utils/media";
import { sendBulkNotification } from "../ducks/actions";

const DefaultComm = (props) => {
  const [csvFile, setCsvFile] = useState([]);
  const [fileData, setFileData] = useState(null);
  const [loader, setLoader] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const featTypes: any = useWatch({ control, name: "types" });
  const messageChar: any = useWatch({ control, name: "message" });

  const csvFileProps = {
    className: "file-upload",
    name: "file",
    multiple: false,
    accept: ".csv",
    showUploadList: false,
    fileList: csvFile?.length > 0 ? csvFile : [],
    onChange(info) {
      setCsvFile(info.fileList);
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onRemove: (file) => {
      setCsvFile([]);
    },
    beforeUpload: (file) => {
      setCsvFile([file]);
      return false;
    },
    csvFile,
  };

  const getPresigned = async (file) => {
    setLoader(true);
    try {
      const { data } = await uploadDocumentMedia({
        name: file?.name,
        mimetype: file?.type,
      });
      if (data?.documentId && data?.signedUrl) {
        await uploadToS3(data.signedUrl, csvFile[0]?.originFileObj);
        setFileData(data);
      }
      setLoader(false);
    } catch (error) {
      console.log("upload error;----->", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    setValue("types", ["SMS"]);
  }, []);

  useEffect(() => {
    const file = csvFile[0]?.originFileObj;
    if (file) getPresigned(file);
    else setFileData(null);
  }, [csvFile]);

  const onFinish = async (values) => {
    if (!csvFile?.length || !fileData) {
      message.info("Please upload a CSV file first");
      return;
    }

    var payload = {
      types: values?.types,
      message: values.message,
      title: values.title,
      CSVFile: {
        id: fileData?.documentId,
        size: csvFile[0]?.size,
      },
    };
    if (values?.priority?.value) payload["priority"] = values?.priority?.value;
    message.loading("Sending...");
    try {
      if (fileData?.documentId && fileData?.signedUrl) {
        await sendBulkNotification(payload);
        message.destroy();
        message.success("Successfully sent");
      }
    } catch (e) {
      message.destroy();
      message.error(e?.data?.message);
      setFileData(null);
    }
  };

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Row gutter={24} style={{}}>
          {featTypes?.length > 0 && featTypes.includes("SMS") && (
            <Col span={24}>
              <h4
                style={{
                  marginBottom: "20px",
                  marginTop: "15px",
                  width: "65%",
                  textDecoration: messageChar?.length > 160 && "underline",
                  fontWeight: "700",
                  color: messageChar?.length > 160 ? "red" : "black",
                }}
              >
                The limit is 160 characters (for text in English) and 70
                characters (for text in English + Arabic), if the entered text
                exceeds the limit, then cost will apply, and SMS consumption
                will be impacted. Please keep your message short and clear.
              </h4>
            </Col>
          )}
          <Col span={24}>
            <p>Upload CSV file with list of mobile numbers</p>

            <Space size={0} className="w-100">
              <Upload showUploadList={false} {...csvFileProps}>
                <Space size={0} className="w-100">
                  <Input
                    readOnly
                    value={csvFile?.[0]?.name}
                    placeholder="Choose a file to upload"
                    disabled={loader}
                  />

                  <Button
                    className="ag-gray-button"
                    disabled={loader}
                    style={{ marginLeft: "10px" }}
                  >
                    Browse
                  </Button>
                </Space>
              </Upload>
              &nbsp; &nbsp;{loader && <LoaderIcon />}
              {csvFile?.length > 0 && !loader && (
                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.preventDefault();
                    setCsvFile([]);
                  }}
                />
              )}
            </Space>
          </Col>
          <Col span={16}>
            <br />
            <div
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <InputField
                label="Title"
                fieldname="title"
                iProps={{
                  placeholder: "Enter title",
                  onKeyDown: (e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault(); // Prevent form submission
                    }
                  },
                }}
                disabled={!(csvFile?.length > 0)}
                initValue=""
                isRequired={
                  featTypes?.length > 0 && featTypes.includes("APPNOTIFICATION")
                    ? true
                    : false
                }
                control={control}
                rules={
                  featTypes?.length > 0 &&
                  featTypes.includes("APPNOTIFICATION") && {
                    required: "Title Required",
                  }
                }
                validate={
                  featTypes?.length > 0 &&
                  featTypes.includes("APPNOTIFICATION") &&
                  errors.title &&
                  "error"
                }
                validMessage={errors.title && errors.title.message}
              />
            </div>
          </Col>

          <Col span={16}>
            <TextAreaField
              label={`Enter message`}
              fieldname="message"
              value={message}
              onChange={(e) => {
                let value = e.target.value;

                value = value.replace(/ {5,}/g, "    ");

                setValue("message", value);
              }}
              iProps={{
                placeholder: "Write your message",
                as: "textarea",
                rows: 4,
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                },
              }}
              disabled={!(csvFile?.length > 0)}
              isRequired={true}
              control={control}
              initValue=""
              cols={40}
              rules={{ required: "Message Required" }}
              validate={errors.message && "error"}
              validMessage={errors.message && errors.message.message}
              id={"message"}
            />
          </Col>

          <Col
            span={15}
            className="main-checkbox"
            style={{ textAlign: "center" }}
          >
            <div
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <InputCheckboxGroup
                fieldname="types"
                options={props?.featureTypeList}
                initValue={["SMS"]}
                control={control}
                iProps={{
                  isDisabled: !(csvFile?.length > 0) || loader,
                }}
                isRequired={true}
                rules={{ required: "Please select one atleast" }}
                validate={errors.types && "error"}
                validMessage={errors.types && errors.types.message}
              />
            </div>
          </Col>

          {featTypes?.length > 0 && featTypes.includes("APPNOTIFICATION") && (
            <Col
              span={15}
              className="main-checkbox"
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ReactSelectField
                fieldname="priority"
                style={{ width: "150px" }}
                label="Please select priority"
                class="severity"
                control={control}
                iProps={{
                  placeholder: "Select priority",
                  onKeyDown: (e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // ⛔ Prevent form submission
                    }
                  },
                }}
                initValue={{ label: "Low (3)", value: 3 }}
                selectOption={[
                  { label: "High (2)", value: 2 },
                  { label: "Low (3)", value: 3 },
                ]}
                isRequired={true}
                rules={{ required: "Please select priority" }}
                validate={errors.priority && "error"}
                validMessage={errors.priority && errors.priority.message}
              />
            </Col>
          )}

          <Col
            span={15}
            style={{
              marginTop: "5px",
              marginBottom: "15px",
              textAlign: "center",
            }}
          >
            <Button
              className="ag-green-button theme_btn"
              htmlType="submit"
              disabled={loader}
            >
              Submit
            </Button>
          </Col>
        </Row>
        <br />
        <br />
      </Form>
    </>
  );
};

export default DefaultComm;
